import axios from "axios";
import api from "lib/api/api";

// 🎯 ADD LESSON
export const ADD_LESSON_REQUEST = "ADD_LESSON_REQUEST";
export const ADD_LESSON_SUCCESS = "ADD_LESSON_SUCCESS";
export const ADD_LESSON_FAILURE = "ADD_LESSON_FAILURE";

export const addLesson = (teacherCourseId, orderNumber) => async (dispatch) => {
  dispatch({ type: ADD_LESSON_REQUEST });
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/teachers/createLesson`,
      null,
      {
        params: { teacherCourseId, orderNumber },
      }
    );
    dispatch({ type: ADD_LESSON_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: ADD_LESSON_FAILURE,
      payload: error.response?.data?.error || "Failed to add lesson",
    });
  }
};

// 📦 FETCH LESSONS
export const FETCH_LESSONS_REQUEST = "FETCH_LESSONS_REQUEST";
export const FETCH_LESSONS_SUCCESS = "FETCH_LESSONS_SUCCESS";
export const FETCH_LESSONS_FAILURE = "FETCH_LESSONS_FAILURE";

export const fetchLessons = (teacherCourseId) => async (dispatch) => {
  dispatch({ type: FETCH_LESSONS_REQUEST });

  try {
    const response = await api.get(
      `/teachers/lesson-teacher-course/${teacherCourseId}`
    );

    // Check if the backend responded with a message instead of data
    if (Array.isArray(response.data)) {
      dispatch({ type: FETCH_LESSONS_SUCCESS, payload: response.data });
    } else {
      dispatch({
        type: FETCH_LESSONS_FAILURE,
        payload: response.data.message || "No lessons exist for this course",
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_LESSONS_FAILURE,
      payload: error.response?.data?.message || "Failed to fetch lessons",
    });
  }
};

export const CLEAR_LESSONS = "CLEAR_LESSONS";

export const clearLessons = () => ({
  type: CLEAR_LESSONS,
});

export const UPDATE_ZOOM_LINK = "UPDATE_ZOOM_LINK";

export const updateZoomLinkAction =
  (lessonId, teacherCourseId, zoomLink) => async (dispatch) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/teachers/lessons/${lessonId}/course/${teacherCourseId}/zoom`,
        { zoomLink }
      );
      dispatch({ type: UPDATE_ZOOM_LINK, payload: { lessonId, zoomLink } });
    } catch (error) {
      console.error("Failed to update zoom link:", error);
    }
  };
